// Desc: Initial state for the redux store
const initialState = {
  sectors: [], // initial sectors state with an array of sectors
  userProfile: null, // initial user profile state with an empty object
};

// export the initial state
export default initialState;
